import AddBankAccountMethodModal from './AddBankAccountMethodModal.component';

export default AddBankAccountMethodModal;
